<template>
  <el-row class="file" :class="className">
    <el-row class="file-hd"
      ><em v-show="image._required" class="is-required mainColor">*</em>{{ image._title }}
      <span class="per-btn mainColor" @click="perImg">预览</span>
      <span class="del-btn mainColor" @click="delImg">删除</span>
    </el-row>
    <el-row class="file-bd relative" :class="{ noPadding: noPadding }" :style="{ width, height }">
      <el-upload drag class="upload" action="#" :show-file-list="false" :http-request="fnUploadRequest" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
        <img v-if="image.image_url && !pdfShow" :src="image.image_url" />
        <pdf v-else-if="image.image_url && pdfShow" :src="image.image_url" style="height:100%;width:100%"></pdf>
        <slot v-else-if="$slots.default"></slot>
        <i v-else class="iconfont icon-icon81"></i>
        <!-- <div slot="tip" class="el-upload__tip">{{image._title}} </div> -->
      </el-upload>
      <p class="requires" v-if="(image.image_type == 'BusinessLicense' && !image._required) || (image.image_type == 'QualificationCertificate' && !image._required)">
        4.2米以下或蓝牌货车无需上传
      </p>
    </el-row>
    <template v-if="image._controlType">
      <el-row class="file-ft" v-if="image._controlType != 'date'">
        <el-input v-if="image._controlType == 'text'" placeholder="请输入描述" v-model="image.description"></el-input>
        <el-input v-if="image._controlType == 'more'" placeholder="请输入描述" v-model="image.description"></el-input>
      </el-row>
      <el-row class="file-ft" v-if="image._controlType == 'date' && showPickerDate">
        <span class="file-ft-label">有效期</span>
        <el-date-picker type="date" value-format="yyyy-MM-dd" :clearable="false" @change="handChangeDate" v-model="image.indate" placeholder="选择日期" :disabled="image._disabled"></el-date-picker>
        <i class="iconfont icon-icon1 unit"></i>
      </el-row>
    </template>
    <!-- <el-dialog center title="合同图片" :visible.sync="isshow" class="dialog-lg" :before-close="handleClose">
      <pdf style="height:100%;width:100%" :src="image.image_url"></pdf>
    </el-dialog> -->
  </el-row>
</template>

<script>
// import pdf from 'vue-pdf'
import { isSuccess } from '@/assets/js/utils'
export default {
  data() {
    return {
      // image_type: null,
      // image_url: null,
      //indate: null
      // description: ''
      showImg: this.isShow,
      isshowImg: false,
      // showPdf: true,
      isshow: false,
      pdfShow: false
    }
  },
  props: {
    image: {
      _title: '',
      _controlType: '',
      _required: false,
      _disabled: false,
      image_type: null,
      image_url: null,
      indate: null,
      description: '',
      showImg: this.showImg
    },
    index: {
      required: false
    },
    showPickerDate: {
      default: true
    },
    noPadding: {
      default: false
    },
    width: {
      default: undefined
    },
    height: {
      default: undefined
    },
    className: {
      default: ''
    }
  },
  created() {},
  // components: {
  //   pdf
  // },
  methods: {
    handChangeDate() {
      let json = {
        type: this.image.image_type,
        indate: this.image.indate
      }
      this.$emit('getDate', json)
    },
    perImg() {
      if (this.image.image_url) {
        this.$viewerApi({ images: [this.image.image_url] })
      }
    },
    delImg() {
      this.image.image_url = ''
      let json = {
        type: this.image.image_type,
        url: ''
      }
      this.$emit('delUrl', json)
    },
    handleAvatarSuccess() {},
    handleClose() {
      this.isshow = false
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const extension = file.name.split('.')[1] === 'pdf'
      const extension2 = file.name.split('.')[1] === 'PDF'
      if (!isJPG && !isPNG && !extension && !extension2) {
        this.$message.error('上传图片只能是 JPG/PNG/PDF 格式!')
      }
      return isJPG || isPNG || extension || extension2
    },
    async fnUploadRequest(option) {
      api('aliyun.sts.verify').then((res) => {
        let data
        if ((data = isSuccess(res))) {
          _global_.uploadIng.push(1)
          let OSS = require('ali-oss')
          let store = new OSS({
            region: data.aliyun_region,
            accessKeyId: data.access_key_id,
            accessKeySecret: data.access_key_secret,
            stsToken: data.security_token,
            bucket: data.aliyun_bucket
          })
          let random_name = this.image.image_type.toLowerCase() + '/' + this.guid() + '.' + option.file.name.split('.').pop()
          store.put(random_name, option.file).then((res) => {
            let arrPDF = []
            if (res.url.indexOf('pdf') === -1) {
              this.image.image_url = res.url
            } else {
              this.pdfShow = true
              arrPDF = res.url.split('://')
              this.image.image_url = 'https://' + arrPDF[1]
            }
            // this.image.image_url = res.url.replace(/static-5j56-com.oss-cn-shanghai.aliyuncs.com/, "static.5j56.com")
            // this.image.image_url = res.url
            // if (this.image.image_url.indexOf('.pdf') !== -1) {
            //   this.showPdf = true
            // } else {
            //   this.showPdf = false
            // }
            let json = {
              type: this.image.image_type,
              url: this.image.image_url,
              index: this.index
            }
            _global_.uploadIng.splice(0, 1)
            this.$emit('getUrl', json)
          })
        }
      })
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.relative {
  position: relative;
}
.requires {
  text-align: center;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #fff;
  background-color: rgba(255, 77, 79, 0.9);
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.noPadding {
  padding: 0;
  border: 0;
  .upload {
    border: 0;
  }
}
.relative {
  position: relative;
}
.column-bd {
  padding-left: 10px;
}
.del-btn {
  position: absolute;
  right: 0%;
  cursor: pointer;
  font-size: 12px;
  line-height: 24px;
  bottom: 2px;
}
.per-btn {
  position: absolute;
  cursor: pointer;
  right: 20%;
  font-size: 12px;
  line-height: 24px;
  bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-file.vue